import React, { useCallback } from "react";

import styles from "./style.module.scss";
import TextField from "../TextField";
import { LocalisedText, useI18n } from "../../i18n";
import { ContactFields } from "../../types";

interface ContactConfirmationFormProps {
  contact: ContactFields;
  setContact: (c: ContactFields) => void;
  isDisabled?: boolean;
}

const ContactConfirmationForm: React.FC<ContactConfirmationFormProps> = (
  props: ContactConfirmationFormProps
) => {
  const i18n = useI18n();
  const { contact, setContact, isDisabled } = props;

  const setName = useCallback(
    (value: string) => {
      setContact({ ...contact, name: value });
    },
    [contact, setContact]
  );
  const setPhone = useCallback(
    (value: string) => {
      setContact({ ...contact, phone: value });
    },
    [contact, setContact]
  );

  return (
    <div className={styles.contactConfirmationForm}>
      <div className={styles.title}>
        <LocalisedText id="view.contactConfirmationForm.contactConfirmation" />
      </div>
      <div className={styles.fields}>
        <TextField
          className={styles.textField}
          labelMessageId="view.contactConfirmationForm.fullName"
          inputType="text"
          inputName="name"
          autoComplete="name"
          placeholderMessageID="view.contactConfirmationForm.fullName"
          value={contact.name}
          onTextChange={setName}
          disabled={isDisabled}
        />
        <TextField
          className={styles.textField}
          labelMessageId="view.contactConfirmationForm.phoneNo"
          inputType="tel"
          inputName="phone"
          autoComplete="phone"
          placeholderMessageID="view.contactConfirmationForm.phoneNo"
          value={contact.phone}
          onTextChange={setPhone}
          disabled={isDisabled}
          alertText={
            contact.errors.phone
              ? i18n.translate(
                  "view.contactConfirmationForm.error.invalidPhone"
                )
              : undefined
          }
        />
      </div>
    </div>
  );
};

export default ContactConfirmationForm;
